import { render, staticRenderFns } from "./SearchReader.vue?vue&type=template&id=4436b028&scoped=true&"
import script from "./SearchReader.vue?vue&type=script&lang=js&"
export * from "./SearchReader.vue?vue&type=script&lang=js&"
import style0 from "./SearchReader.vue?vue&type=style&index=0&id=4436b028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4436b028",
  null
  
)

export default component.exports